module.exports = __webpack_public_path__ + "img/comment-exclamation.43fd4189.svg";